import { ArrowCounterClockwise, FunnelSimple } from "@phosphor-icons/react";
import clsx from "clsx";
import { useState } from "react";

import ExpandCollapseIcon from "common/components/ExpandCollapseIcon";
import { Button } from "common/components/ui/Button";

import FiltersSelection from "./Filters";

import type {
  NavigatorFilters,
  SelectedNavigatorFilters,
} from "../../../../../types";

export default function DesktopFilters({
  isLoading,
  returnedFilters,
  selectedFilters,
  setSelectedFilters,
}: {
  isLoading: boolean;
  returnedFilters: NavigatorFilters;
  selectedFilters: SelectedNavigatorFilters;
  setSelectedFilters: (selectedFilters: SelectedNavigatorFilters) => void;
}) {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div
      className={clsx(
        "flex flex-col rounded-4xl border border-black-200 transition-[width]",
        isExpanded ? "w-1/2" : "w-1/3",
      )}
    >
      <div className="flex items-center gap-x-2.5 border-b border-black-200 p-3">
        <div className="rounded-2xl bg-black-100 p-2.5">
          <FunnelSimple size={20} />
        </div>
        <span className="mr-auto text-md-bold">Filters</span>
        {!!selectedFilters.length && (
          <Button
            variant="secondary-black"
            size="sm"
            leftIcon={<ArrowCounterClockwise />}
            onClick={() => setSelectedFilters([])}
          >
            Reset all
          </Button>
        )}
        <Button
          variant="outline-black"
          intent="iconOnly"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <ExpandCollapseIcon isExpanded={isExpanded} />
        </Button>
      </div>

      <div className="flex gap-3 p-3">
        <FiltersSelection
          isSingleColumn={!isExpanded}
          isLoading={isLoading}
          returnedFilters={returnedFilters}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
      </div>
    </div>
  );
}
